// rbContracts.js — current-deal RB contract terms (OTC via the vault,
// harvested 2026-07-16). Qualifier source for the rb-touches v2 competition
// hint: the vet-arrival share hit scales with the vet's CONTRACT, not his
// trailing share (r²=0.002). Thresholds used by competitionHints:
// apyM >= 6 = real money (~2% of 2026 cap), < 3 = cheap depth.
//
// Keyed suffix-stripped lowercase name (same suffix regex family as
// findPlayerHist) -> { apyM, gtdM, team }. 144 rostered RBs, no key
// collisions after stripping. apyM/gtdM in $M.

import contracts from "./rbContracts2026.json";

function stripKey(name) {
  return name.replace(/\s+(Jr\.?|Sr\.?|II|III|IV|V)$/i, "").trim().toLowerCase();
}

export const RB_CONTRACTS = new Map(
  contracts.players.map(p => [stripKey(p.name), { apyM: p.apyM, gtdM: p.gtdM, team: p.team }])
);

// Shared lookup so callers don't re-implement the suffix strip.
export function findRbContract(name) {
  return name ? RB_CONTRACTS.get(stripKey(name)) ?? null : null;
}
